import messages from './messages.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default } from './main';
export const addFlagLabel = messages.addFlag;
export const removeFlagLabel = messages.removeFlag;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as FlagButtonItem } from './button-item';
